import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as hrmsService from "../../services/hrmsService";
import { EmptyState, LoadState, PageHeader } from "./hrComponents";
import { cardStyle, pageStyle, statusBadge, statusLabel, useLoad } from "./hrUi";

// ORG-03: the reporting tree. Branches open and close; a manager shows how many people are below them.
export function OrgNode({ node, depth, onOpen, defaultOpen }) {
  const [open, setOpen] = useState(defaultOpen);
  const hasKids = node.children && node.children.length > 0;
  return (
    <div>
      <div className="d-flex align-items-center" style={{ padding: "8px 0 8px " + depth * 24 + "px", borderBottom: "1px solid #F3F4F6" }}>
        <button
          type="button"
          aria-label={hasKids ? (open ? "Collapse" : "Expand") : undefined}
          onClick={() => hasKids && setOpen(!open)}
          style={{ width: 24, background: "none", border: "none", color: "#6B7280", cursor: hasKids ? "pointer" : "default" }}
        >
          {hasKids ? (open ? "▾" : "▸") : ""}
        </button>
        <button type="button" onClick={() => onOpen(node)} style={{ background: "none", border: "none", textAlign: "left", padding: 0 }}>
          <span style={{ fontWeight: 600, color: "#111827" }}>{node.full_name}</span>
          <span style={{ fontSize: 12, color: "#6B7280", marginLeft: 8 }}>{[node.designation_name, node.department_name].filter(Boolean).join(" · ")}</span>
        </button>
        {node.status && node.status !== "ACTIVE" ? (
          <span style={{ ...statusBadge(node.status), marginLeft: 8 }}>{statusLabel(node.status)}</span>
        ) : null}
        {hasKids ? <span style={{ fontSize: 12, color: "#6B7280", marginLeft: "auto" }}>{node.headcount} below</span> : null}
      </div>
      {open && hasKids ? node.children.map((c) => <OrgNode key={c.employee_id} node={c} depth={depth + 1} onOpen={onOpen} defaultOpen={false} />) : null}
    </div>
  );
}

export default function OrgChart() {
  const navigate = useNavigate();
  const { data, loading, error, reload } = useLoad(() => hrmsService.getOrgChart(), []);
  const roots = data?.roots || [];
  return (
    <div style={pageStyle}>
      <PageHeader title="Org Chart" subtitle={data ? `${data.total} people` : undefined} />
      <LoadState loading={loading} error={error} onRetry={reload}>
        {roots.length === 0 ? (
          <EmptyState title="No employees yet" />
        ) : (
          <div style={{ ...cardStyle, padding: "8px 16px" }}>
            {roots.map((r) => (
              <OrgNode key={r.employee_id} node={r} depth={0} defaultOpen onOpen={(n) => navigate(`/hr/employees/${n.employee_id}`)} />
            ))}
          </div>
        )}
      </LoadState>
    </div>
  );
}
